import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="loading-overlay"
      [class.show]="isVisible"
      role="status"
      [attr.aria-busy]="isVisible"
      [attr.aria-label]="title"
      [style.background-color]="'rgba(0,0,0,' + backdropOpacity + ')'"
      [attr.aria-hidden]="!isVisible"
    >
      <div class="loading-container">
        <div class="loading-icon" [style.--size.px]="size" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div class="loading-text" *ngIf="message || showProgress">
          <div class="title">{{ title }}</div>
          <div class="message" *ngIf="message">{{ message }}</div>
          <div class="progress" *ngIf="showProgress">{{ progress }}%</div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .loading-overlay {
        position: fixed;
        inset: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: opacity 0.25s ease, visibility 0.25s ease;
      }
      .loading-overlay.show {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
      }

      .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
      }
      .loading-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }
      .loading-icon span {
        width: calc(var(--size, 60px) * 0.2);
        height: calc(var(--size, 60px) * 0.2);
        min-width: 10px;
        min-height: 10px;
        border-radius: 50%;
        background: var(--app-color-brand, #ff7900);
        animation: loading-bounce 1s infinite ease-in-out;
      }
      .loading-icon span:nth-child(2) {
        animation-delay: 0.12s;
      }
      .loading-icon span:nth-child(3) {
        animation-delay: 0.24s;
      }
      @keyframes loading-bounce {
        0%,
        80%,
        100% {
          transform: translateY(0);
          opacity: 0.55;
        }
        40% {
          transform: translateY(-6px);
          opacity: 1;
        }
      }

      .loading-text {
        color: #fff;
        text-align: center;
        font: 500 14px/1.4 system-ui, -apple-system, Segoe UI, Roboto,
          sans-serif;
      }
      .loading-text .title {
        font-weight: 600;
      }
      .loading-text .message,
      .loading-text .progress {
        opacity: 0.9;
      }

      @media (prefers-reduced-motion: reduce) {
        .loading-overlay {
          transition: none;
        }
      }
    `,
  ],
})
export class LoadingComponent implements OnChanges {
  @Input() isVisible = false;
  @Input() title = 'Yükleniyor...';
  @Input() message = '';
  @Input() showProgress = false;
  @Input() progress = 0;

  @Input() src: string = 'assets/media/loader.svg';
  @Input() size = 60;
  @Input() backdropOpacity = 0.4;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isVisible']) {
      document.body.style.overflow = this.isVisible ? 'hidden' : '';
    }
  }
}
